<div [ngClass]="!isHidden ? 'show-modal' : 'hide-modal'">
  <div class="modal-content">
    <span (click)="closeModal()" class="close">&times;</span>
    <div class="error-message-container">
      <img class="error-image" src="../../../assets/ice-cream.svg" alt="error-image" />
      <div class="error-text-container">
        <h4 class="error-title">It happens!</h4>
        <p class="error-message-text">{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</div>
